import { useEffect, useState } from 'react';

const mq = () => window.matchMedia('(prefers-color-scheme: dark)');

export const useSystemColorScheme = (): 'dark' | 'light' => {
  const [scheme, setScheme] = useState<'dark' | 'light'>(() =>
    mq().matches ? 'dark' : 'light',
  );

  useEffect(() => {
    const media = mq();
    const handler = (e: MediaQueryListEvent) => setScheme(e.matches ? 'dark' : 'light');
    media.addEventListener('change', handler);
    return () => media.removeEventListener('change', handler);
  }, []);

  return scheme;
};
